import axios from 'axios';
import config from '../hoa-config';
import datastore from '../store/hoa-datastore';


axios.defaults.baseURL = config.baseUrl;

export default class InvoiceApiServices {

    static async getInvoiceDataServices() {
        return await axios.get(`/getInvoiceConfigData?env=${datastore.env}&date=${new Date().toLocaleDateString()}`);
    }

	static async createInvoiceDataField(orgId:string, dataJson:any, updatedBy:string) {
		return await axios.post(`/createInvoiceDataField`, {
            orgId:orgId,
            dataJson: dataJson,
            updatedBy:updatedBy
        });
	}

    static async updateInvoiceDataField(id:string, dataJson:any, updatedBy:string) {
		return await axios.post(`/updateInvoiceDataField`, {
            id:id,
            dataJson: dataJson,
            updatedBy:updatedBy
        });
	}

    static async getInvoiceDataConfiguratorByOrganization(orgId:string) {
        return await axios.get(`/getInvoiceConfigDataByOrg?env=${datastore.env}&orgId=${orgId}`);
    }
}